<template>
  <div id="insuranceList">
    <el-row>
      <el-col :span="24">
        <div class="about-top">
        </div></el-col>
    </el-row>
    <div class="flex-wrap insuranceLists">
      <ul class="space-around classifyList">
        <li @click="classifySelected(1, $event)">
          <div class="selected">
            <img :src="classifyIndex == 1 ? `../../static/images/about/classify/classifySelected-1.png` : `../../static/images/about/classify/classify-1.png`">
            <div>团体意外险</div>
          </div>
        </li>
        <li @click="classifySelected(2, $event)">
          <div>
            <img :src="classifyIndex == 2 ? `../../static/images/about/classify/classifySelected-2.png` : `../../static/images/about/classify/classify-2.png`">
            <div>雇主责任险</div>
          </div>
        </li>
        <li @click="classifySelected(3, $event)">
          <div>
            <img :src="classifyIndex == 3 ? `../../static/images/about/classify/classifySelected-3.png` : `../../static/images/about/classify/classify-3.png`">
            <div>关税保证保险</div>
          </div>
        </li>
        <li @click="classifySelected(4, $event)">
          <div>
            <img :src="classifyIndex == 4 ? `../../static/images/about/classify/classifySelected-4.png` : `../../static/images/about/classify/classify-4.png`">
            <div>车险</div>
          </div>
        </li>
        <li @click="classifySelected(5, $event)">
          <div>
            <img :src="classifyIndex == 5 ? `../../static/images/about/classify/classifySelected-5.png` : `../../static/images/about/classify/classify-5.png`">
            <div>履约保证险</div>
          </div>
        </li>
      </ul>
      <div class="productList">
        <div v-if="classifyIndex == 1" v-html="productLists"></div>
        <div v-else-if="classifyIndex == 2" v-html="productLists"></div>
        <div v-else-if="classifyIndex == 3" v-html="productLists"></div>
        <div v-else-if="classifyIndex == 4" v-html="productLists"></div>
        <div v-else-if="classifyIndex == 5" v-html="productLists"></div>
      </div>
    </div>
    <el-dialog
      style="margin-left: -100px;width: 500px"
      :visible.sync="textDialog">
      <div style="font-size: 10px;color: black">
        <p style="font-size: 20px;text-align: center;font-weight: bolder;">关于停售“国寿财团体意外保险”产品的公告</p>
        <p>各位尊敬的客户：</p>
        <p>根据《中国银保监会办公厅关于进一步规范保险机构互联网人身保险业务有关事项的通知》（银保监办发〔2021〕108号）相关要求，需对涉及互联网人身险保险产品进行调整，故我公司将自2022年1月1日0时停止销售“国寿财团体意外保险产品”保险产品。</p>
        <p>对于涉及上述产品保险合同，在保险期间届满前，客户仍享有原保险合同约定的相关保障服务，产品停售后将不再接受续保申请。</p>
        <p>如果您有任何疑问，正迅保险经纪有限公司全国统一客服热线020-82526981 竭诚为您服务。</p>

        <p>特此公告。</p>
        <p style="text-align: right;font-weight: bolder;">正迅保险经纪有限公司</p>
        <p style="text-align: right;font-weight: bolder;">2021年12月29日</p>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import baseUrl from '../tool/baseUrl';
  import productList from '../../static/js/product/productList';
  export default {
    name: "insuranceList",
    data() {
      return {
        ejsinoInsurance : {},
        ejsinoInsuranceList: [],
        classifyIndex: 1,
        productLists: ``,
        eShopProductIdList: '100421,100433,100422,100430,100431,100432,100423,100427,100428,100429,100425,100426',
        textDialog: false
      }
    },
    methods:{
      toLifeInsurance(){
        this.ls.removeItem('dynamicValidateForm');
        // this.$router.push('insureManagement');
        this.$router.push({name: 'productShowDetail', params: {showType: 1 }});
        // this.textDialog = true;
      },
      toTariff(){
          this.$router.push({name: 'productShowDetail', params: {showType: 2 }});
      },
      goTo(title){
        this.current = title;
        if (title == 'login'){
          if (this.$route.name == 'login') return;
          this.$router.push({name: `${title}`, query: { returnUrl: window.location.href }});
        }else {
          this.$router.push({name: `${title}`});
        }
      },
      // -- 跳转Ejsino页面
      toEjsinoInsurance(id){
        this.$confirm('因产品调整,暂时不支持投保!','提示',{
          center: true,
          type:'info',
          showConfirmButton: false,
          showCancelButton: false
        });
        return ;
        const that = this;
        if (!that.$$.checkLogin()) {
          that.$$.confirm({
            message: "您还未登录，是否登录？",
            onOk: function () {
              that.goTo('login');
            },
          });
          return false;
        }
        this.$router.push({name: 'ejsinoInsureDetails', query: {productId: id }});
      },
      // 泰康车险
      taiKangAutoInsurance(id){
        this.$router.push({path: '/taiKang/vehicleInfo'});
        // this.$router.push({name: 'vehicleInfo', query: {quoteIdNum: 'ATzGhc6m9TpcOsJE6azj2/umAWeRYVOfrUBQmEp0iu4=' }});
      },
      getInsuranceListEjisno(){
        this.axios.post('/management/mobileInsuranceInfo/getInsuranceList?fullNameString=e超市&filtrationSaleCompany=1').then((response) => {
          let data = response.data;
          if( data.success ){
            // 根据type拆分
            let json = {};
            data.datas.list.forEach(item => {
              if(!json[item.productIntroduce]){
                this.ejsinoInsurance[item.productIntroduce] = [];
                this.ejsinoInsurance[item.productIntroduce].push(item);
                json[item.productIntroduce] = 1;
              }else{
                this.ejsinoInsurance[item.productIntroduce].push(item);
              }
            });
            for (let ejsinoInsuranceKey in this.ejsinoInsurance) {
              this.ejsinoInsuranceList.push(this.ejsinoInsurance[ejsinoInsuranceKey])
            }
          }
        });
      },
      //-- 目录切换
      classifySelected(index, event){
        let el = event.currentTarget;
        $(el).children('div').addClass('selected');
        $(el).siblings('li').children('div').removeClass('selected');
        this.classifyIndex = index;
        this.loadList(index);
      },
      //-- 加载列表数据
      loadList(index){
        let that = this,
          list = productList.data[index],
          html = ``;

        for (let i in list){

          const {presentation, picture} = list[i];

          if (Object.keys(list[i]).length > 3){
            html += `<div class="productListInfo flex-wrap">
                      <img class="variousProductsImages" src="${picture}">
                      <div class="presentation">
                        <div class="title">${i}</div>
                        ${that.$$.isValidObj(presentation) ? loadPresentation(presentation) : ``}
                      </div>
                      <div class="productListDetails">
                        ${that.$$.isValidObj(list[i]) ? loadProductList(list[i]) : ``}
                      </div>
                    </div>`;
          }else{
            html += `<div class="productListInfo flex-wrap">
                      <img class="variousProductsImages" src="${picture}">
                      <div class="presentation">
                        <div class="title">${i}</div>
                        ${that.$$.isValidObj(presentation) ? loadPresentation(presentation) : ``}
                      </div>
                      <div class="productDetails">
                        ${that.$$.isValidObj(list[i]) ? loadProductDetails(list[i]) : ``}
                      </div>
                    </div>`;
          }
        }

        that.productLists = html;

        //-- 加载简介
        function loadPresentation(data) {
          let html = ``;
          for (let i in data){
            html += `<div class="flex-start">
                      <span class="punctuation">•</span>
                      <span>${data[i]}</span>
                    </div>`;
          }
          return html;
        }

        //-- 加载多个方案
        function loadProductList(data) {
          let html = ``;
          for (let i in data){
            const {price, promotionExpenses, scheme} = data[i];
            if (i == 'presentation' || i == 'picture') continue;

            html += `<div class="space-between">
                      <div class="scheme">${scheme}</div>
                      <div class="price"><span>${price}</span>元起</div>
                      <div class="promotionExpenses">推广费<span>${promotionExpenses}</span></div>
                      <div class="immediatelyInsure" onclick="immediatelyInsure(${i})" data-id="${i}">立即投保</div>
                    </div>`;
          }
          return html;
        }

        //-- 加载单个方案
        function loadProductDetails(data) {
          let html = ``;
          for (let i in data){
            const {price, promotionExpenses, scheme} = data[i];
            if (i === 'presentation' || i == 'picture') continue;

            html += `<div class="space-between">
                        ${that.$$.isValidObj(price) ? `<div class="price">
                          <span class="barType"></span>
                          <span>${price}</span>元起
                        </div>`:`<div></div>`}
                        ${that.$$.isValidObj(promotionExpenses) ? `<div class="promotionExpenses">
                          <span class="barType"></span>
                          <div>
                            <div style="font-size: 2.5rem;color: #F2613F"><span>${promotionExpenses}</span></div>
                            <span>推广费</span>
                          </div>
                        </div>`:`<div></div>`}
                        <div class="immediatelyInsure" onclick="immediatelyInsure(${i})" data-id="${i}">立即投保</div>
                      </div>`;
          }
          return html;
        }
      },
      //-- 立即投保
      immediatelyInsure(id){
        if (id == '100414'){
          this.toLifeInsurance();       // 国寿财 - 团体意外保险
        } else if (id == '100409'){
          this.toTariff();              // 国寿财 - 关税险
        } else if (this.eShopProductIdList.includes(id)){
          this.toEjsinoInsurance(id);   // E超市产品
        } else if (id == '100464'){
          this.taiKangAutoInsurance(id);   // 泰康车险
        } else if (id == '111'){
          this.$router.push({name: `buyerPaymentGuaranteeInsurance`});
        }
      },
    },
    mounted() {
      this.loadList(1);

      //-- h5添加文本时，绑定点击事件到window
      window['immediatelyInsure'] = (id)=> {
        this.immediatelyInsure(id);
      };

    }
  }
</script>

<style scoped>
  .about-top{
    max-height: 28.13rem;
    padding-top: 23%;
    background: url("../../static/images/home/insuranceList-top.png") no-repeat center / cover;
  }
  #insuranceList{
    width: 100%;
    height: 100%;
  }

  /* 产品列表 */
  .classifyList{
    width: 50rem;
    height: 8rem;
    margin: 0 auto;
    background: #FFFFFF;
    border: 0px solid #FFFFFF;
    box-shadow: 0rem 0rem 1rem 0rem rgba(24, 24, 24, 0.16);
    border-radius: 10px;
    position: absolute;
    top: -2rem;
    left: 50%;
    transform: translate(-50%, 0);
  }

  .classifyList>li{
    flex: 1;
    height: 100%;
    text-align: center;
    color: #333333;
    font-weight: bold;
    position: relative;
  }

  .classifyList>li>div.selected{
    width: calc(100% + 1rem);
    height: calc(100% + 1rem);
    border-radius: 10px;
    background: #F2613F;
    color: #ffffff;
    position: absolute;
    top: -.5rem;
    left: -.5rem;
  }

  .classifyList>li>div>img{
    width: 5rem;
    height: 5rem;
    margin: 1rem auto .3rem;
  }

  .productList{
    width: 100%;
    margin: 0 auto;
    padding: 10rem 15vw 7rem;
    overflow-x: auto;
  }

  .productList>div{
    min-width: 70rem;
  }

  /deep/ .variousProductsImages{
    width: 15rem;
    height: 15rem;
    display: inline-block;
    object-fit: scale-down;
    border-right: 1px dashed rgba(0, 0, 0, 0.14);
  }

  /deep/ .productListInfo{
    height: 15rem;
    margin-bottom: 3rem;
    background: #FFFFFF;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.14);
  }

  /deep/ .productListInfo>div{
    font-size: 1rem;
    vertical-align: middle;
  }

  /deep/ .productListInfo .presentation{
    width: 18rem;
    height: 100%;
    overflow-y: auto;
    padding: 1rem 0 1rem 1rem;
    color: #999999;
  }
  /deep/ .productList>li::-webkit-scrollbar,
  /deep/ .productListInfo .presentation::-webkit-scrollbar{
    width: 2px;
    height: .5rem;
  }
  /deep/ .productList>li::-webkit-scrollbar-thumb,
  /deep/ .productListInfo .presentation::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    background: rgba(0,0,0,0.2);
  }
  /deep/ .productList>li::-webkit-scrollbar-track,
  /deep/ .productListInfo .presentation::-webkit-scrollbar-track {/*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
  }

  /deep/ .productListInfo .presentation>.title{
    margin-bottom: .8rem;
    color: #F2613F;
    font-size: 1.25rem;
  }

  /deep/ .productListInfo .presentation .punctuation{
    margin-right: 5px;
  }

  /deep/ .productListInfo .presentation span{
    font-size: 12px;
    display: inline-block;
  }

  /* 多方案 */
  /deep/ .productListDetails{
    width: calc(100% - 33rem);
    line-height: calc(14rem / 4);
    padding: 0 1rem;
  }

  /deep/ .productListDetails>div{
    border-bottom: 1px solid #E7E7E7;
    padding: 0 1rem;
    font-weight: 400;
  }

  /deep/ .productListInfo .scheme{
    flex: 1;
    font-size: 1.25rem;
    color: #333333;
  }
  /deep/ .productListInfo .price{
    flex: 1;
    color: #F2613F;
  }
  /deep/ .productListInfo .price>span{
    font-size: 1.63rem;
  }
  /deep/ .productListInfo .promotionExpenses{
    flex: 1.5;
    color: #999999;
  }
  /deep/ .productListInfo .promotionExpenses>span{
    color: #F2613F;
    font-size: 1.63rem;
    padding-left: 3px;
  }
  /deep/ .productListInfo .immediatelyInsure{
    width: 8.19rem;
    height: 2.31rem;
    line-height: 2.31rem;
    text-align: center;
    font-size: 1.25rem;
    color: #ffffff;
    background: #F2613F;
    border-radius: .5rem;
    margin-top: .9rem;
    cursor: pointer;
  }

  /* 单方案 */
  /deep/ .productDetails{
    width: calc(100% - 33rem);
    line-height: 15rem;
    padding: 0 2rem 0 5rem;
  }

  /deep/ .productDetails .immediatelyInsure{
    margin-top: 6.3rem;
  }

  /deep/ .productDetails .barType{
    width: 0.13rem;
    height: 2.5rem;
    border-left: 2px solid #E7E7E7;
    margin: 6.3rem 1rem 0;
  }

  /deep/ .productDetails .promotionExpenses>div{
    display: inline-block;
    line-height: 2.5rem;
    vertical-align: middle;
    text-align: center;
  }


  /* 旧列表（待删除） */
  .insuranceLists{
    width: 100%;
    margin: 0 auto;
    position: relative;
  }

  .insuranceLists>div.selected{
    border-radius: 1rem;
    color: #333333;
    background: #FFFFFF;
    margin: 0 auto 2rem;
    box-shadow: 0rem 0rem 1rem 0rem rgba(0, 0, 0, 0.35);
    position: relative;
  }

  .insuranceImages{
    max-width: 17.38rem;
    width: 100%;
    height: 15.69rem;
    border: none;
  }

  .insuranceInfo{
    padding: 1.25rem;
    max-width: 17.38rem;
  }

  .insuranceLists .ejsinoType .ejisnoUl>li:hover .disc{
    background: #FF7052;
    color: #FF7052;
  }

  .insuranceLists .ejsinoType .ejisnoUl>li:hover .ejisno{
    color: #FF7052;
    cursor: pointer;
    text-decoration: underline;
  }

  .insuranceLists .lifeInsuranceType:hover{
    background: #FF7052;
    color: #FFFFFF;
  }

  .insuranceLists .tariffType:hover{
    background: #FF7052;
    color: #FFFFFF;
  }

  .insuranceLists .lifeInsuranceType:hover .title{
    color: #FFFFFF;
  }

  .insuranceLists .tariffType:hover .title{
    color: #FFFFFF;
  }

  .insuranceLists .lifeInsuranceType:hover .bottomRod{
    background: #ffffff;
  }

  .insuranceLists .tariffType:hover .bottomRod{
    background: #ffffff;
  }

  .insuranceLists>div .title{
    color: #FF7052;
    font-size: 1rem;
    font-weight: bold;
  }

  .insuranceLists>div ul{
    padding: 1rem 0;
  }

  .insuranceLists>div ul li{
    line-height: 2rem;
    text-align: left;
    font-size: 1rem;
    font-weight: 500;
  }

  .insuranceLists>div ul li .disc{
    width: 0.75rem;
    height: 0.75rem;
    background: #CCCCCC;
    border-radius: 50%;
    display: inline-block;
    margin-right: 0.81rem;
  }

  .bottomRod{
    width: 6.25rem;
    height: 0.63rem;
    background: #FF7052;
    border-radius: 1rem;
    margin: 0 auto;
    position: absolute;
    bottom: 1rem;
    left: 50%;
    transform: translate(-50%, 0);
  }
</style>



// WEBPACK FOOTER //
// src/components/insuranceList.vue